import React from 'react';
import UserLayout from '../../components/Layout/UserLayout';
import EditProfileLight from './EditProfileLight';
import { setSiteSettings } from '../../actions/siteSettings';

const title = 'Profil bearbeiten';

export default {

  path: '/user/edit',

  async action({ store }) {

    // From Redux Store
    let isAuthenticated = store.getState().runtime.isAuthenticated;


    if (!isAuthenticated) {
      return { redirect: '/login' };
    }

    await store.dispatch(setSiteSettings());

    return {
      title,
      component: <UserLayout><EditProfileLight title={title} /></UserLayout>,
    };
  },

};
